<template>

    <div ref="senderContainer" class="senders">


    </div>

</template>

<script>

export default {

    name: 'scrolling-senders',

    props: {

        samples: {
            type: Array,
            default: () => []
        }
    },

    watch: {
        samples: function (newSamples) {
            this.localSamples = [...this.localSamples, ...newSamples]
        }
    },


    data() {
        return {
            localSamples: [],
            intervalFunction: function () {},
            index: 0
        }
    },

    mounted() {
        this.startUpdate()
    },

    methods: {

        addSender(data) {

            const html = document.createElement('div')
            html.className = 'anim-sender-scroll text-baseRegular-2 mt__8'
            html.append(data.sender)

            this.$refs.senderContainer.prepend(html)

        },

        stopUpdate() {
            clearInterval(this.intervalFunction)
        },

        startUpdate() {

            this.intervalFunction = setInterval(() => {
                this.update()
            }, 1000)
        },

        update() {
            if(this.index < this.localSamples.length) {
                this.addSender(this.localSamples[this.index])
                this.index++
            }
        }

    },

    destroyed() {
        this.stopUpdate()
    }

}

</script>

<style lang="scss">


.anim-sender-scroll {
    animation: anim-scroll 2s 1 ease-out normal;
    opacity: 0;
}

div.anim-sender-scroll:nth-child(1) {
    opacity: 1
}

;
div.anim-sender-scroll:nth-child(2) {
    opacity: 0.8
}

;
div.anim-sender-scroll:nth-child(3) {
    opacity: 0.6
}

;
div.anim-sender-scroll:nth-child(4) {
    opacity: 0.4
}

;
div.anim-sender-scroll:nth-child(5) {
    opacity: 0.2
}

;

@keyframes anim-scroll {
    0% {
        opacity: 0;
        height: 0;
    }

    10% {
        opacity: 0;
        height: 20px;
    }

    20% {
        opacity: 1;
        height: 20px;
    }

    100% {
        opacity: 1;
        height: 20px;
    }
}

</style>

<style lang="scss" scoped>

.senders {
    overflow: hidden;
    height: 150px;
    width: 100%;
}

</style>
